import React, { useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AdminLayout } from '../adminLayout';
import { IntlMessages } from '../../../helper/langHelper';
import { getUsersByType } from '../../../services/admin/users';
import { UsersContainer, UsersHeader, LoaderWrapper, IconButton } from './Users.styles';

import { Table } from '../../../components/uielements/table';
import TabButton from '../../../components/uielements/tab/Tabbutton';
import { UserDemoteIcon, UserPromteIcon } from '../../../icons';
import UserPromoteModal from './modals/UserPromoteModal';
import UserDemoteModal from './modals/UserDemoteModal';

const USER_TABS = [
  { key: 'USER', label: 'Users' },
  { key: 'ADMIN', label: 'Admin' },
  { key: 'COUNCIL', label: 'Council' },
];

const Users = () => {
  const [userType, setUserType] = useState('ADMIN');
  const [page, setPage] = useState(0);
  const [perPage] = useState(10);
  const [userPromoteData, setUserPromoteData] = useState(null);
  const [userDemoteData, setUserDemoteData] = useState(null);

  const { data, isLoading, isFetching, isError } = useQuery({
    queryKey: ['adminUsers', userType, page, perPage],
    queryFn: () => getUsersByType(page, perPage, userType),
  });

  const tableData = data?.data ?? [];
  const total = data?.total ?? 0;

  const handleTabChange = (key) => {
    setUserType(key);
    setPage(0);
  };

  const columns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.name" />,
        accessor: 'userId.username',
        width: '25%',
      },
      {
        Header: <IntlMessages id="table.col.email" />,
        accessor: 'userId.email',
        width: '35%',
      },
      {
        Header: <IntlMessages id="table.col.phone" />,
        accessor: 'userId.phone',
        width: '25%',
      },
      {
        Header: <IntlMessages id="table.col.actions" defaultMessage="Actions" />,
        accessor: 'actions',
        isAction: true,
        width: '20%',
      },
    ],
    []
  );

  const actionList = [
    ...(userType === 'USER'
      ? [
          (data) => (
            <IconButton onClick={() => setUserPromoteData(data)} variant="promote">
              <UserPromteIcon style={{ width: '24px', height: '24px' }} />
            </IconButton>
          ),
        ]
      : []),

    ...(userType === 'ADMIN' || userType === 'COUNCIL'
      ? [
          (data) => (
            <IconButton onClick={() => setUserDemoteData(data)}>
              <UserDemoteIcon style={{ width: '24px', height: '24px' }} />
            </IconButton>
          ),
        ]
      : []),
  ];

  if (isLoading) {
    return (
      <AdminLayout pageTitle="Users" activeTab="Users">
        <LoaderWrapper>Loading...</LoaderWrapper>
      </AdminLayout>
    );
  }
  if (isError) {
    return (
      <AdminLayout pageTitle="Users" activeTab="Users">
        <LoaderWrapper>Opps! Error Encounter </LoaderWrapper>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout activeTab="users">
      <UsersContainer>
        <UsersHeader>
          <IntlMessages id="nav.users" />
          <TabButton tabs={USER_TABS} active={userType} onChange={handleTabChange} />
        </UsersHeader>

        <Table
          data={tableData}
          columns={columns}
          hasFooter={true}
          actions={actionList}
          page={page}
          pageSize={perPage}
          prevPage={() => setPage((p) => Math.max(0, p - 1))}
          nextPage={() => setPage((p) => p + 1)}
          total={total}
        />

        {userPromoteData && (
          <UserPromoteModal
            onClose={() => setUserPromoteData(null)}
            userName={userPromoteData.userId.username}
            userId={userPromoteData.userId._id}
          />
        )}
        {userDemoteData && (
          <UserDemoteModal
            onClose={() => setUserDemoteData(null)}
            userName={userDemoteData.userId.username}
            userId={userDemoteData.userId._id}
          />
        )}
      </UsersContainer>
    </AdminLayout>
  );
};

export default Users;
